import { ConfirmModal } from "@/shared/components/confirm-modal";

interface IProps {
    open: boolean;
    onConfirm?(): void;
    onCancel?(): void;
};

const AddPaymentLaterConfirm = ({ open, onConfirm, onCancel }: IProps) => (
    <ConfirmModal
        open={open}
        title="Add Payment Later"
        confirmText={<span className="font-dmSans font-bold">I Understand</span>}
        cancelText={<span className="font-dmSans font-bold">Add Payment Now</span>}
        cancelVariant="outlined"
        onConfirm={onConfirm}
        onCancel={onCancel}
    >
        <div className="text-center">
            <div>
                I understand that by choosing to <b>Add Payment Later</b>, I must add a payment method
                upon receiving my first invoice.
            </div>
            <div className="mt-4">
                I will look out for my first invoice so there are no delays in receiving my MedBox.
            </div>
        </div>
    </ConfirmModal>
);

export default AddPaymentLaterConfirm;